import api, { BASE_URL, baseHeaders } from '@/services/api';
import { ApiError } from '@/services/ApiError';

import { type QualityAssuranceProcedure, type QualityAssuranceProcedureWithProductsId } from '../types';

export const getProcedures = async () => {
  return await api.get<QualityAssuranceProcedure[]>('qualityAssuranceProcedures');
};

export const getProceduresWithProductsId = async () => {
  return await api.get<QualityAssuranceProcedureWithProductsId[]>('qualityAssuranceProcedures/productsId');
};

export const getProcedure = async (id: number) => {
  return await api.get<QualityAssuranceProcedure>(`qualityAssuranceProcedures/${id}`);
};

export const getProcedureHtml = async (id: number) => {
  const response = await fetch(`${BASE_URL}/api/qualityAssuranceProcedures/${id}/html`, { headers: baseHeaders });
  if (!response.ok) {
    throw new ApiError(response.status, response.statusText);
  }
  return await response.text();
};

export const updateProcedure = async (procedure: QualityAssuranceProcedure) => {
  await api.put(`qualityAssuranceProcedures/${procedure.idQualityAssuranceProcedure}`, procedure);
  return procedure;
};

export const createProcedure = async (procedure: QualityAssuranceProcedure) => {
  return await api.post<QualityAssuranceProcedure>('qualityAssuranceProcedures', procedure);
};

export const deleteProcedure = async (id: number) => await api.delete(`qualityAssuranceProcedures/${id}`);
